import { render, staticRenderFns } from "./TitleBreadcrumb.vue?vue&type=template&id=1780f7b0&scoped=true"
import script from "./TitleBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TitleBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./TitleBreadcrumb.vue?vue&type=style&index=0&id=1780f7b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780f7b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1780f7b0')) {
      api.createRecord('1780f7b0', component.options)
    } else {
      api.reload('1780f7b0', component.options)
    }
    module.hot.accept("./TitleBreadcrumb.vue?vue&type=template&id=1780f7b0&scoped=true", function () {
      api.rerender('1780f7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/PageHeader/TitleBreadcrumb.vue"
export default component.exports